import type { ThemeOptions } from '@mui/material';
import { fontSizes } from '../../resources/fontSizes';

export const componentOverrides = (themebase: Partial<ThemeOptions>) => {
  return {
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'unset',
          },
          elevation1: {
            boxShadow: 'none',
          },
        },
      },

      MuiCard: {
        styleOverrides: {
          root: {
            // eslint-disable-next-line
            // @ts-ignore
            background: themebase?.palette?.background?.lighter,
          },
        },
      },

      MuiButton: {
        styleOverrides: {
          root: {
            minWidth: '13rem',
            maxWidth: '100%',
            padding: '0.5rem',
          },
        },
      },

      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: '0 1.25rem 0 0.83333rem',
            fontFamily:
              '"Roboto", Helvetica, Arial, "Arial Unicode", "Lucida Sans Unicode", sans-serif',
          },
          head: {
            // eslint-disable-next-line
            // @ts-ignore
            backgroundColor: themebase.palette?.background?.tableHeader,
            color: 'inherit',
            fontWeight: 700,
            fontSize: fontSizes.normal,
            lineHeight: '1.5rem',
          },
          body: {
            fontSize: fontSizes.normal,
            borderBottom: `0.25rem solid ${themebase?.palette?.background?.default}`,

            '& a': {
              '&:hover': {
                textDecoration: 'underline',
              },
            },
          },
          stickyHeader: {
            backgroundColor: '',
            borderBottom: `.5rem solid ${themebase?.palette?.background?.default}`,
          },
          footer: {
            borderBottom: 'initial',
            fontSize: fontSizes.normal,
          },
        },
      },

      MuiTablePagination: {
        styleOverrides: {
          root: {
            fontSize: fontSizes.normal,
            fontFamily:
              '"Roboto", Helvetica, Arial, "Arial Unicode", "Lucida Sans Unicode", sans-serif',
          },
          actions: {
            display: 'flex',
            marginRight: 0,
          },
          select: {
            padding: 2,
            borderRadius: 2,
            top: 'auto !important',
            bottom: '100% !important',
          },
          selectIcon: {
            top: '50%',
            transform: 'translateY(-50%)',
          },
          toolbar: {
            height: 'inherit',
            minHeight: 38,
          },
        },
      },

      MuiTableRow: {
        styleOverrides: {
          root: {
            height: '3.3333333333rem',
          },
          head: {
            height: '4rem',
            fontWeight: 700,
            borderBottom: `6px solid ${themebase?.palette?.background?.default}`,
          },
        },
      },

      MuiTableFooter: {
        styleOverrides: {
          root: {
            display: 'flex',
            justifyContent: 'flex-end',
            overflow: 'hidden',
            borderTop: `6px solid ${themebase?.palette?.background?.default}`,
          },
        },
      },
    } satisfies ThemeOptions['components'],
  };
};
